import { createRoot } from 'react-dom/client';
import { Theme } from '@classify/react-core-components/Theme';
import CompanionLinkButton from '../components/CompanionLinkButton';
function isCompanionUrl(url: URL) {
  return /openclassrooms\./.test(url.hostname) && url.pathname === '/companion';
}
export default function handleCompanionLinks(domContainer: HTMLElement, projectId?: number) {
  const links = Array.from(domContainer.getElementsByTagName('a'));
  if (!links.length) {
    return null;
  }
  return links.map((linkElement: HTMLAnchorElement) => [new URL(linkElement.href), linkElement] as [URL, HTMLAnchorElement]).filter(([, linkElement]) => isCompanionUrl(new URL(linkElement.href))).forEach(([url, linkElement], n) => {
    const prompt = url.searchParams.get('prompt') || 'tutoring';
    if (!prompt) return;
    const rootContainer = document.createElement('span');
    rootContainer.style.display = 'block';
    rootContainer.style.textAlign = 'center';
    rootContainer.style.padding = '8px 0';
    linkElement.parentNode?.replaceChild(rootContainer, linkElement);
    const root = createRoot(rootContainer);
    root.render(<Theme productionPrefix={`companion_${n}`}>
          <CompanionLinkButton prompt={prompt} buttonText={linkElement.innerHTML} projectId={projectId} />
        </Theme>);
  });
}